import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import { mockData } from '../data/mock';
import scoreCard from '../assets/governance-score-card.jpg';

const Hero = () => {
  const navigate = useNavigate();
  const { features } = mockData;

  return (
    <header id="hero" className="relative pt-32 pb-24 md:pt-40 md:pb-32 px-6 overflow-hidden">
      <div className="max-w-7xl mx-auto grid lg:grid-cols-2 gap-16 lg:gap-12 items-center relative z-10">
        <div className="max-w-2xl animate-in fade-in slide-in-from-bottom-8 duration-1000 fill-mode-both">
          <div className="inline-flex items-center gap-2.5 px-4 py-2 rounded-full border border-ink/10 mb-8 bg-white/60 backdrop-blur-md shadow-saas-sm">
            <span className="w-2 h-2 rounded-full bg-lime animate-pulse"></span>
            <span className="text-[11px] font-bold tracking-[0.2em] uppercase text-ink/80">Governance Improvement Platform</span>
          </div>

          <h1 className="text-4xl md:text-6xl lg:text-[4rem] font-bold leading-[1.05] mb-6 tracking-tight text-ink">
            The Governance <span className="highlighter">Review</span> System.
          </h1>

          <p className="text-lg md:text-xl text-ink/60 mb-10 max-w-xl leading-relaxed font-medium">
            Conduct consultant-level governance reviews internally using a structured
            framework built by governance professionals.
          </p>

          <div className="flex flex-col sm:flex-row gap-4">
            <button
              onClick={() => navigate('/health-check')}
              data-testid="start-review-btn"
              className="bg-lime text-ink hover:bg-lime-hover rounded-full px-8 py-4 text-base font-semibold shadow-sm inline-flex items-center justify-center gap-2 transition-all active:scale-95 hover:shadow-md"
            >
              Assess Your Governance Health <ArrowRight className="w-5 h-5" />
            </button>
            <button
              onClick={() =>
                document.getElementById('how-it-works')?.scrollIntoView({ behavior: 'smooth' })
              }
              className="border border-ink/10 text-ink bg-white/50 hover:bg-white rounded-full px-8 py-4 text-base font-medium inline-flex items-center justify-center transition-all hover:shadow-sm"
            >
              How It Works
            </button>
          </div>

          <p className="mt-10 text-[11px] font-bold tracking-[0.15em] uppercase text-ink/40">
            Consultant-level governance reviews — without the consultants.
          </p>
        </div>

        <div className="relative hidden lg:block animate-in fade-in slide-in-from-right-12 duration-1000 delay-300 fill-mode-both">
          <div className="absolute inset-0 bg-gradient-to-tr from-lime/20 to-transparent blur-3xl -z-10 rounded-full transform -translate-x-10 translate-y-10"></div>
          <div className="border border-ink/10 rounded-2xl p-2.5 bg-white/60 backdrop-blur-xl shadow-saas transform rotate-1 hover:rotate-0 transition-transform duration-700">
            <div className="bg-white rounded-xl border border-ink/5 p-2 shadow-sm overflow-hidden relative">
              <img
                src={scoreCard}
                alt="GovernWell governance review results"
                draggable="false"
                className="w-full h-auto block rounded-lg ring-1 ring-ink/5 select-none"
              />
              <div className="absolute inset-0" aria-hidden="true"></div>
            </div>
          </div>
        </div>
      </div>

      <div className="max-w-7xl mx-auto mt-24 pt-10 border-t border-ink/10 relative z-10 animate-in fade-in duration-1000 delay-500 fill-mode-both">
        <div className="flex flex-wrap items-center justify-center gap-4">
          {features.map((f, i) => (
            <span
              key={i}
              className="inline-flex items-center gap-2 px-5 py-2 rounded-full bg-white/80 border border-ink/5 shadow-saas-sm text-sm font-medium text-ink/70 hover:bg-white transition-colors"
            >
              <span className="inline-block w-1.5 h-1.5 rounded-full bg-lime shrink-0" />
              {f}
            </span>
          ))}
        </div>
      </div>
    </header>
  );
};

export default Hero;
